// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { AlertCircle, CheckCircle, Eye, EyeOff, ArrowLeft } from 'lucide-react';

// const ResetPassword = () => {
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [message, setMessage] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');
//   const [isLoading, setIsLoading] = useState(true);
//   const [isSuccess, setIsSuccess] = useState(false);
//   const [hasValidToken, setHasValidToken] = useState(false);
//   const [accessToken, setAccessToken] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [fieldErrors, setFieldErrors] = useState({
//     newPassword: '',
//     confirmPassword: ''
//   });
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Load Lexend font
//     const link = document.createElement('link');
//     link.href = 'https://fonts.googleapis.com/css2?family=Lexend:wght@300;400;500;600;700&display=swap';
//     link.rel = 'stylesheet';
//     if (!document.head.querySelector('link[href*="Lexend"]')) {
//       document.head.appendChild(link);
//     }

//     return () => {
//       const existingLink = document.head.querySelector('link[href*="Lexend"]');
//       if (existingLink) {
//         document.head.removeChild(existingLink);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     const handlePasswordReset = async () => {
//       try {
//         // Check for development override in URL
//         const urlParams = new URLSearchParams(window.location.search);
//         const isDev = urlParams.get('dev') === 'true';
        
//         // If we're on production URL but have dev flag, redirect to localhost
//         if (window.location.hostname === 'dashboard.abnexus.com' && isDev) {
//           console.log('Development flag detected, redirecting to localhost');
//           const localhostUrl = window.location.href.replace('https://dashboard.abnexus.com', 'http://localhost:3000');
//           window.location.href = localhostUrl;
//           return;
//         }
        
//         // Extract access token from URL hash
//         const hashParams = new URLSearchParams(window.location.hash.substring(1));
//         const token = hashParams.get('access_token');
        
//         if (token) {
//           console.log('Found Supabase access token');
//           setAccessToken(token);
//           setHasValidToken(true);
//           setIsLoading(false);
//         } else {
//           // No valid token, redirect to appropriate login
//           setErrorMessage('Invalid or expired reset link. Redirecting to login...');
//           setTimeout(() => {
//             const isLocalhost = window.location.hostname === 'localhost';
//             const redirectUrl = isLocalhost 
//               ? 'http://localhost:3000/' 
//               : 'https://dashboard.abnexus.com/';
//             window.location.href = redirectUrl;
//           }, 3000);
//           setIsLoading(false);
//         }
//       } catch (error) {
//         console.error('Error handling password reset:', error);
//         setErrorMessage('An error occurred. Please try again.');
//         setIsLoading(false);
//       }
//     };

//     handlePasswordReset();
//   }, [navigate]);

//   const validatePassword = (password) => {
//     if (!password) return '';
//     if (password.length < 8) {
//       return 'Password must be at least 8 characters long';
//     }
//     const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
//     if (!specialCharRegex.test(password)) {
//       return 'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)';
//     }
//     return '';
//   };

//   const handlePasswordChange = (e) => {
//     const { name, value } = e.target;
    
//     if (name === 'newPassword') {
//       setNewPassword(value);
//       const error = validatePassword(value);
//       setFieldErrors(prev => ({ ...prev, newPassword: error }));
      
//       // Also check confirm password if it exists
//       if (confirmPassword && value !== confirmPassword) {
//         setFieldErrors(prev => ({ ...prev, confirmPassword: 'Passwords do not match' }));
//       } else if (confirmPassword && value === confirmPassword) {
//         setFieldErrors(prev => ({ ...prev, confirmPassword: '' }));
//       }
//     } else if (name === 'confirmPassword') {
//       setConfirmPassword(value);
//       if (newPassword && value !== newPassword) {
//         setFieldErrors(prev => ({ ...prev, confirmPassword: 'Passwords do not match' }));
//       } else {
//         setFieldErrors(prev => ({ ...prev, confirmPassword: '' }));
//       }
//     }
    
//     // Clear main error when user starts typing
//     if (errorMessage) {
//       setErrorMessage('');
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setErrorMessage('');
    
//     // Validate passwords match
//     if (newPassword !== confirmPassword) {
//       setErrorMessage('Passwords do not match');
//       return;
//     }
    
//     // Validate password strength
//     if (newPassword.length < 8) {
//       setErrorMessage('Password must be at least 8 characters long');
//       return;
//     }

//     setIsLoading(true);
    
//     try {
//       // Use your existing backend API with the Supabase access token
//       const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      
//       const response = await fetch(`${apiUrl}/auth/reset-password`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ 
//           resetToken: accessToken, // Send the Supabase access token
//           newPassword 
//         }),
//       });
      
//       const data = await response.json();
      
//       if (response.ok) {
//         setIsSuccess(true);
//         setMessage('Password reset successful! You will be redirected to the login page.');
//         setTimeout(() => {
//           // Dynamically determine redirect based on current environment
//           const isLocalhost = window.location.href.includes('localhost:3000');
//           const redirectUrl = isLocalhost || process.env.NODE_ENV === 'development' 
//             ? 'http://localhost:3000/' 
//             : 'https://dashboard.abnexus.com/';
//           window.location.href = redirectUrl;
//         }, 3000);
//       } else {
//         setErrorMessage(data.message || 'An error occurred. Please try again.');
//       }
//     } catch (error) {
//       console.error('Password reset error:', error);
//       setErrorMessage('An error occurred. Please try again.');
//     }
    
//     setIsLoading(false);
//   };

//   // AB Nexus Logo Component
//   const ABNexusLogo = () => (
//     <div className="flex items-center mb-8">
//       <div className="w-16 h-16 mr-3 relative">
//         <img 
//           src="/images/logoOnly.png" 
//           alt="AB Nexus Logo" 
//           className="w-full h-full object-contain"
//         />
//       </div>
//       <div className="text-white text-3xl font-semibold tracking-wide">AB NEXUS</div>
//     </div>
//   );

//   // Show loading state while checking token
//   if (isLoading && !hasValidToken) {
//     return (
//       <div 
//         className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden"
//         style={{
//           fontFamily: 'Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
//           background: '#0A0A0A'
//         }}
//       >
//         {/* Background Effects */}
//         <div className="fixed inset-0 z-0">
//           <div 
//             className="absolute inset-0"
//             style={{
//               background: `
//                 radial-gradient(circle at 25% 25%, rgba(103, 109, 255, 0.1) 0%, transparent 50%),
//                 radial-gradient(circle at 75% 75%, rgba(103, 109, 255, 0.05) 0%, transparent 50%)
//               `
//             }}
//           />
//         </div>

//         <div className="text-center relative z-10">
//           <div className="w-8 h-8 border-2 border-gray-600 border-t-purple-500 rounded-full animate-spin mx-auto mb-4"></div>
//           <p className="text-gray-300">Verifying reset link...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div 
//       className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden"
//       style={{
//         fontFamily: 'Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
//         background: '#0A0A0A'
//       }}
//     >
//       {/* Background Effects */}
//       <div className="fixed inset-0 z-0">
//         <div 
//           className="absolute inset-0"
//           style={{
//             background: `
//               radial-gradient(circle at 25% 25%, rgba(103, 109, 255, 0.1) 0%, transparent 50%),
//               radial-gradient(circle at 75% 75%, rgba(103, 109, 255, 0.05) 0%, transparent 50%)
//             `
//           }}
//         />
//         <div 
//           className="absolute inset-0 opacity-30"
//           style={{
//             backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(103, 109, 255, 0.15) 1px, transparent 0)',
//             backgroundSize: '40px 40px'
//           }}
//         />
//       </div>

//       {/* Loading Overlay */}
//       {isLoading && (
//         <div className="fixed inset-0 bg-black bg-opacity-95 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="w-8 h-8 border-2 border-gray-600 border-t-purple-500 rounded-full animate-spin"></div>
//         </div>
//       )}

//       {/* Main Container */}
//       <div 
//         className="w-full max-w-md relative z-10"
//         style={{
//           background: 'rgba(21, 21, 21, 0.95)',
//           backdropFilter: 'blur(20px)',
//           border: '1px solid rgba(103, 109, 255, 0.2)',
//           borderRadius: '24px',
//           boxShadow: `
//             0 25px 50px rgba(0, 0, 0, 0.5),
//             0 0 0 1px rgba(103, 109, 255, 0.1),
//             inset 0 1px 0 rgba(255, 255, 255, 0.05)
//           `
//         }}
//       >
//         <div className="p-12">
//           <div className="text-center mb-8">
//             <ABNexusLogo />
//           </div>

//           <div className="mb-10">
//             <Link
//               to="/"
//               className="flex items-center gap-2 text-gray-400 hover:text-white mb-4 transition-colors duration-200"
//             >
//               <ArrowLeft className="w-4 h-4" />
//               <span className="text-sm">Back to Login</span>
//             </Link>
//             <h1 className="text-3xl font-semibold text-white mb-2 tracking-tight">
//               Set New Password
//             </h1>
//             <p className="text-gray-400 text-sm leading-relaxed">
//               Create a secure password to regain access to your portfolio dashboard
//             </p>
//           </div>

//           {/* Error Message */}
//           {errorMessage && (
//             <div className="bg-red-900 bg-opacity-20 border border-red-800 text-red-300 p-4 mb-6 rounded-lg">
//               <div className="flex">
//                 <AlertCircle className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
//                 <span className="text-sm">{errorMessage}</span>
//               </div>
//             </div>
//           )}

//           {/* Success Message */}
//           {isSuccess && (
//             <div className="bg-green-900 bg-opacity-20 border border-green-800 text-green-300 p-4 mb-6 rounded-lg">
//               <div className="flex">
//                 <CheckCircle className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
//                 <span className="text-sm">{message}</span>
//               </div>
//             </div>
//           )}

//           {/* Info Message for Valid Token */}
//           {hasValidToken && !isSuccess && (
//             <div className="bg-blue-900 bg-opacity-20 border border-blue-800 text-blue-300 p-4 mb-6 rounded-lg">
//               <div className="flex">
//                 <CheckCircle className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
//                 <span className="text-sm">Reset link verified. Please create your new secure password.</span>
//               </div>
//             </div>
//           )}

//           {hasValidToken && !isSuccess ? (
//             <form onSubmit={handleSubmit} className="space-y-6">
//               {/* New Password Input */}
//               <div>
//                 <label htmlFor="newPassword" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
//                   New Password
//                 </label>
//                 <div className="relative">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     id="newPassword"
//                     name="newPassword"
//                     value={newPassword}
//                     onChange={handlePasswordChange}
//                     className={`w-full px-5 py-4 pr-12 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
//                       fieldErrors.newPassword 
//                         ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
//                         : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
//                     }`}
//                     style={{
//                       background: 'rgba(21, 21, 21, 0.8)',
//                       backdropFilter: 'blur(10px)',
//                       fontFamily: 'Lexend, sans-serif'
//                     }}
//                     placeholder="Create a secure password"
//                     required
//                     minLength="8"
//                   />
//                   <button
//                     type="button"
//                     className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
//                     onClick={() => setShowPassword(!showPassword)}
//                   >
//                     {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
//                   </button>
//                 </div>
//                 {fieldErrors.newPassword && (
//                   <p className="text-red-400 text-xs mt-2 flex items-center">
//                     <AlertCircle className="w-3 h-3 mr-1" />
//                     {fieldErrors.newPassword}
//                   </p>
//                 )}
//               </div>

//               {/* Confirm Password Input */}
//               <div>
//                 <label htmlFor="confirmPassword" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
//                   Confirm New Password
//                 </label>
//                 <div className="relative">
//                   <input
//                     type={showConfirmPassword ? "text" : "password"}
//                     id="confirmPassword"
//                     name="confirmPassword"
//                     value={confirmPassword}
//                     onChange={handlePasswordChange}
//                     className={`w-full px-5 py-4 pr-12 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
//                       fieldErrors.confirmPassword 
//                         ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
//                         : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
//                     }`}
//                     style={{
//                       background: 'rgba(21, 21, 21, 0.8)',
//                       backdropFilter: 'blur(10px)',
//                       fontFamily: 'Lexend, sans-serif'
//                     }}
//                     placeholder="Confirm your new password"
//                     required
//                     minLength="8"
//                   />
//                   <button
//                     type="button"
//                     className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
//                     onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                   >
//                     {showConfirmPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
//                   </button>
//                 </div>
//                 {fieldErrors.confirmPassword && (
//                   <p className="text-red-400 text-xs mt-2 flex items-center">
//                     <AlertCircle className="w-3 h-3 mr-1" />
//                     {fieldErrors.confirmPassword}
//                   </p>
//                 )}
//               </div>

//               {/* Submit Button */}
//               <div className="pt-2">
//                 <button
//                   type="submit"
//                   disabled={isLoading}
//                   className="w-full py-4 px-6 rounded-xl text-white font-semibold text-sm relative overflow-hidden transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl disabled:opacity-50"
//                   style={{
//                     background: isLoading 
//                       ? '#4a5568' 
//                       : 'linear-gradient(135deg, #676DFF 0%, #5A60E8 100%)',
//                     boxShadow: '0 8px 25px rgba(103, 109, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
//                   }}
//                 >
//                   {isLoading ? (
//                     <span className="flex items-center justify-center">
//                       <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
//                       Updating Password...
//                     </span>
//                   ) : (
//                     'Update Password & Sign In'
//                   )}
//                 </button>
//               </div>

//               {/* Back to Login Link */}
//               <div className="text-center">
//                 <p className="text-sm text-gray-400">
//                   Remember your password?{' '}
//                   <Link
//                     to="/"
//                     className="font-medium transition-colors duration-200"
//                     style={{ color: '#676DFF' }}
//                   >
//                     Return to Sign In
//                   </Link>
//                 </p>
//               </div>
//             </form>
//           ) : !isSuccess ? (
//             <div className="bg-red-900 bg-opacity-20 border border-red-800 text-red-300 p-6 rounded-lg text-center">
//               <AlertCircle className="h-8 w-8 mx-auto mb-3" />
//               <p className="text-sm">{errorMessage}</p>
//             </div>
//           ) : null}
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes float {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-20px) rotate(180deg); }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ResetPassword;

import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AlertCircle, CheckCircle, Eye, EyeOff, ArrowLeft } from 'lucide-react';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [hasValidToken, setHasValidToken] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const navigate = useNavigate();

  // Mobile detection hook
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Load Lexend font
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Lexend:wght@300;400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    if (!document.head.querySelector('link[href*="Lexend"]')) {
      document.head.appendChild(link);
    }

    return () => {
      const existingLink = document.head.querySelector('link[href*="Lexend"]');
      if (existingLink) {
        document.head.removeChild(existingLink);
      }
    };
  }, []);

  useEffect(() => {
    const handlePasswordReset = async () => {
      try {
        // Check for development override in URL
        const urlParams = new URLSearchParams(window.location.search);
        const isDev = urlParams.get('dev') === 'true';
        
        // If we're on production URL but have dev flag, redirect to localhost
        if (window.location.hostname === 'dashboard.abnexus.com' && isDev) {
          console.log('Development flag detected, redirecting to localhost');
          const localhostUrl = window.location.href.replace('https://dashboard.abnexus.com', 'http://localhost:3000');
          window.location.href = localhostUrl;
          return;
        }
        
        // Extract access token from URL hash
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const token = hashParams.get('access_token');
        
        if (token) {
          console.log('Found Supabase access token');
          setAccessToken(token);
          setHasValidToken(true);
          setIsLoading(false);
        } else {
          // No valid token, redirect to appropriate login
          setErrorMessage('Invalid or expired reset link. Redirecting to login...');
          setTimeout(() => {
            const isLocalhost = window.location.hostname === 'localhost';
            const redirectUrl = isLocalhost 
              ? 'http://localhost:3000/' 
              : 'https://dashboard.abnexus.com/';
            window.location.href = redirectUrl;
          }, 3000);
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Error handling password reset:', error);
        setErrorMessage('An error occurred. Please try again.');
        setIsLoading(false);
      }
    };

    handlePasswordReset();
  }, [navigate]);

  const validatePassword = (password) => {
    if (!password) return '';
    if (password.length < 8) {
      return 'Password must be at least 8 characters long';
    }
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    if (!specialCharRegex.test(password)) {
      return 'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)';
    }
    return '';
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'newPassword') {
      setNewPassword(value);
      const error = validatePassword(value);
      setFieldErrors(prev => ({ ...prev, newPassword: error }));
      
      // Also check confirm password if it exists
      if (confirmPassword && value !== confirmPassword) {
        setFieldErrors(prev => ({ ...prev, confirmPassword: 'Passwords do not match' }));
      } else if (confirmPassword && value === confirmPassword) {
        setFieldErrors(prev => ({ ...prev, confirmPassword: '' }));
      }
    } else if (name === 'confirmPassword') {
      setConfirmPassword(value);
      if (newPassword && value !== newPassword) {
        setFieldErrors(prev => ({ ...prev, confirmPassword: 'Passwords do not match' }));
      } else {
        setFieldErrors(prev => ({ ...prev, confirmPassword: '' }));
      }
    }
    
    // Clear main error when user starts typing
    if (errorMessage) {
      setErrorMessage('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    
    // Validate passwords match
    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords do not match');
      return;
    }
    
    // Validate password strength
    if (newPassword.length < 8) {
      setErrorMessage('Password must be at least 8 characters long');
      return;
    }

    setIsLoading(true);
    
    try {
      // Use your existing backend API with the Supabase access token
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      
      const response = await fetch(`${apiUrl}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          resetToken: accessToken, // Send the Supabase access token
          newPassword 
        }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setIsSuccess(true);
        setMessage('Password reset successful! You will be redirected to the login page.');
        setTimeout(() => {
          // Dynamically determine redirect based on current environment
          const isLocalhost = window.location.href.includes('localhost:3000');
          const redirectUrl = isLocalhost || process.env.NODE_ENV === 'development' 
            ? 'http://localhost:3000/' 
            : 'https://dashboard.abnexus.com/';
          window.location.href = redirectUrl;
        }, 3000);
      } else {
        setErrorMessage(data.message || 'An error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Password reset error:', error);
      setErrorMessage('An error occurred. Please try again.');
    }
    
    setIsLoading(false);
  };

  // Mobile-responsive AB Nexus Logo Component
  const ABNexusLogo = () => (
    <div className="flex items-center mb-6 sm:mb-8">
      <div className="w-12 h-12 sm:w-16 sm:h-16 mr-2 sm:mr-3 relative">
        <img 
          src="/images/logoOnly.png" 
          alt="AB Nexus Logo" 
          className="w-full h-full object-contain"
        />
      </div>
      <div className="text-white text-2xl sm:text-3xl font-semibold tracking-wide">AB NEXUS</div>
    </div>
  );

  // Show loading state while checking token
  if (isLoading && !hasValidToken) {
    return (
      <div 
        className="min-h-screen flex items-center justify-center p-4 sm:p-6 relative overflow-hidden"
        style={{
          fontFamily: 'Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          background: 'var(--bg-base)'
        }}
      >
        {/* Background Effects */}
        <div className="fixed inset-0 z-0">
          <div 
            className="absolute inset-0"
            style={{
              background: `
                radial-gradient(circle at 25% 25%, rgba(103, 109, 255, 0.1) 0%, transparent 50%),
                radial-gradient(circle at 75% 75%, rgba(103, 109, 255, 0.05) 0%, transparent 50%)
              `
            }}
          />
        </div>

        <div className="text-center relative z-10">
          <div className="w-6 h-6 sm:w-8 sm:h-8 border-2 border-gray-600 border-t-purple-500 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-300 text-sm sm:text-base">Verifying reset link...</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 sm:p-6 relative overflow-hidden"
      style={{
        fontFamily: 'Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        background: 'var(--bg-base)'
      }}
    >
      {/* Background Effects */}
      <div className="fixed inset-0 z-0">
        <div 
          className="absolute inset-0"
          style={{
            background: `
              radial-gradient(circle at 25% 25%, rgba(103, 109, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 75% 75%, rgba(103, 109, 255, 0.05) 0%, transparent 50%)
            `
          }}
        />
        <div 
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(103, 109, 255, 0.15) 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}
        />
      </div>

      {/* Loading Overlay */}
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-95 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="w-6 h-6 sm:w-8 sm:h-8 border-2 border-gray-600 border-t-purple-500 rounded-full animate-spin"></div>
        </div>
      )}

      {/* Main Container - Mobile responsive */}
      <div 
        className={`w-full ${isMobile ? 'max-w-sm' : 'max-w-md'} relative z-10`}
        style={{
          background: 'rgba(21, 21, 21, 0.95)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(103, 109, 255, 0.2)',
          borderRadius: '24px',
          boxShadow: `
            0 25px 50px rgba(0, 0, 0, 0.5),
            0 0 0 1px rgba(103, 109, 255, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.05)
          `
        }}
      >
        <div className="p-6 sm:p-8 lg:p-12">
          <div className="text-center mb-6 sm:mb-8">
            <ABNexusLogo />
          </div>

          <div className="mb-8 sm:mb-10">
            <Link
              to="/"
              className="flex items-center gap-2 text-gray-400 hover:text-white mb-4 transition-colors duration-200"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm">Back to Login</span>
            </Link>
            <h1 className="text-2xl sm:text-3xl font-semibold text-white mb-2 tracking-tight">
              Set New Password
            </h1>
            <p className="text-gray-400 text-sm leading-relaxed">
              Create a secure password to regain access to your portfolio dashboard
            </p>
          </div>

          {/* Error Message */}
          {errorMessage && (
            <div className="bg-red-900 bg-opacity-20 border border-red-800 text-red-300 p-3 sm:p-4 mb-4 sm:mb-6 rounded-lg">
              <div className="flex">
                <AlertCircle className="h-4 w-4 sm:h-5 sm:w-5 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-xs sm:text-sm">{errorMessage}</span>
              </div>
            </div>
          )}

          {/* Success Message */}
          {isSuccess && (
            <div className="bg-green-900 bg-opacity-20 border border-green-800 text-green-300 p-3 sm:p-4 mb-4 sm:mb-6 rounded-lg">
              <div className="flex">
                <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-xs sm:text-sm">{message}</span>
              </div>
            </div>
          )}

          {/* Info Message for Valid Token */}
          {hasValidToken && !isSuccess && (
            <div className="bg-blue-900 bg-opacity-20 border border-blue-800 text-blue-300 p-3 sm:p-4 mb-4 sm:mb-6 rounded-lg">
              <div className="flex">
                <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-xs sm:text-sm">Reset link verified. Please create your new secure password.</span>
              </div>
            </div>
          )}

          {hasValidToken && !isSuccess ? (
            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              {/* New Password Input */}
              <div>
                <label htmlFor="newPassword" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
                  New Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="newPassword"
                    name="newPassword"
                    value={newPassword}
                    onChange={handlePasswordChange}
                    className={`w-full px-4 sm:px-5 py-3 sm:py-4 pr-12 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
                      fieldErrors.newPassword 
                        ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
                        : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
                    }`}
                    style={{
                      background: 'rgba(21, 21, 21, 0.8)',
                      backdropFilter: 'blur(10px)',
                      fontFamily: 'Lexend, sans-serif'
                    }}
                    placeholder="Create a secure password"
                    required
                    minLength="8"
                  />
                  <button
                    type="button"
                    className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                  </button>
                </div>
                {fieldErrors.newPassword && (
                  <p className="text-red-400 text-xs mt-2 flex items-center">
                    <AlertCircle className="w-3 h-3 mr-1" />
                    {fieldErrors.newPassword}
                  </p>
                )}
              </div>

              {/* Confirm Password Input */}
              <div>
                <label htmlFor="confirmPassword" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
                  Confirm New Password
                </label>
                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={handlePasswordChange}
                    className={`w-full px-4 sm:px-5 py-3 sm:py-4 pr-12 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
                      fieldErrors.confirmPassword 
                        ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
                        : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
                    }`}
                    style={{
                      background: 'rgba(21, 21, 21, 0.8)',
                      backdropFilter: 'blur(10px)',
                      fontFamily: 'Lexend, sans-serif'
                    }}
                    placeholder="Confirm your new password"
                    required
                    minLength="8"
                  />
                  <button
                    type="button"
                    className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                  </button>
                </div>
                {fieldErrors.confirmPassword && (
                  <p className="text-red-400 text-xs mt-2 flex items-center">
                    <AlertCircle className="w-3 h-3 mr-1" />
                    {fieldErrors.confirmPassword}
                  </p>
                )}
              </div>

              {/* Submit Button */}
              <div className="pt-2">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full py-3 sm:py-4 px-6 rounded-xl text-white font-semibold text-sm relative overflow-hidden transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl disabled:opacity-50"
                  style={{
                    background: isLoading 
                      ? '#4a5568' 
                      : 'linear-gradient(135deg, #676DFF 0%, #5A60E8 100%)',
                    boxShadow: '0 8px 25px rgba(103, 109, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
                  }}
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center">
                      <div className="w-3 h-3 sm:w-4 sm:h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                      Updating Password...
                    </span>
                  ) : (
                    'Update Password & Sign In'
                  )}
                </button>
              </div>

              {/* Back to Login Link */}
              <div className="text-center">
                <p className="text-sm text-gray-400">
                  Remember your password?{' '}
                  <Link
                    to="/"
                    className="font-medium transition-colors duration-200"
                    style={{ color: '#676DFF' }}
                  >
                    Return to Sign In
                  </Link>
                </p>
              </div>
            </form>
          ) : !isSuccess ? (
            <div className="bg-red-900 bg-opacity-20 border border-red-800 text-red-300 p-4 sm:p-6 rounded-lg text-center">
              <AlertCircle className="h-6 w-6 sm:h-8 sm:w-8 mx-auto mb-3" />
              <p className="text-xs sm:text-sm">{errorMessage}</p>
            </div>
          ) : null}
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
      `}</style>
    </div>
  );
};

export default ResetPassword;